import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from 'redux';
import PropTypes from "prop-types";

import { createMessage } from "~app/actions/app";
import { addAttachment, removeAttachment } from "~app/actions/nodeList";
import Attachment from "~app/components/Attachment";
import { validateFileSize } from "~app/utils/validation";
import { withT } from "~app/BundleProvider";

class NodeAttachmentList extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    attachments: PropTypes.array,
    createMessage: PropTypes.func,
    t: PropTypes.func,
  };

  handleFileUpload = ({event, t}) => {
    event.preventDefault();

    let reader = new FileReader();
    let file = event.target.files[0];

    if (!file) return;
    if (file.error) return;

    const fileNameIsTaken = this.props.attachments.find(
      attachment => attachment.fileName === file.name
    );

    if (fileNameIsTaken) {
      const message = t("file-being-used");
      return this.props.createMessage(message);
    }

    const validationError = validateFileSize(file);
    if (validationError)
      return this.props.createMessage(validationError, "error");

    reader.readAsDataURL(file);

    reader.onloadend = () => {
      const attachment = {
        fileName: file.name,
        data: reader.result,
      };

      this.props.addAttachment(this.props.id, attachment);
    };
  };

  handleRemoveAttachment = fileName => {
    this.props.removeAttachment(this.props.id, fileName);
  };

  handleFileRef = () => {
    this.refs.fileField.click();
  }

  render() {
    const { t } = this.props;
    return (
      <div className="NodeAttachmentList">
        {/* This is a file-upload input disguised as a link
          See: https://coderwall.com/p/uer3ow/total-input-type-file-style-control-with-pure-css
        */}
        {/* eslint-disable */}
        <label
          className="attachments__upload-wrapper"
          tabIndex="0"
          aria-label={t("attach-file")}
          role="button"
          onKeyPress={(event) => {
            if(event.key === 'Enter' || event.key === ' '){
              this.handleFileRef();
            }
          }}>
          <img
            className="attachments__paperclip-icon"
            src={require("~app/resources/images/icons/PaperClipIcon.svg")}
            alt={t("attachment")}
          />
          <span className="attachments__link-underline">
            {t("files-to-attach")} 
          </span>
          <input
            ref="fileField"
            className="attachments__file-upload"
            type="file"
            name={t("file")}
            onChange={e => this.handleFileUpload({event: e, t})}
            value=""
            tabIndex="-1"
          />
        </label>
        {/* eslint-enable */}
        {this.props.attachments.map(({ fileName }, index) => (
          <Attachment
            id={this.props.id}
            key={fileName}
            fileName={fileName}
            onRemoveClick={this.handleRemoveAttachment}
          />
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const node = state.nodeList.present.nodes.find(
    node => node.id === ownProps.id
  );
  const attachments = node.attachments;
  return { attachments };
};

const mapDispatchToProps = {
  addAttachment,
  removeAttachment,
  createMessage,
};

export default compose(
  withT,
  connect(mapStateToProps, mapDispatchToProps)
)(NodeAttachmentList);



// WEBPACK FOOTER //
// ./src/pages/Main/NodeList/NodeAttachmentList.js